module.exports = {
	environment: process.env.ELEVENTY_ENV,
	name: "Mona Offshore Wind Project",
	url:
		process.env.ELEVENTY_ENV === "dev"
			? "https://develop--bp-enbw.netlify.app/"
			: "https://morganandmona.com/",

	base: {
		contact_address: "FREEPOST MONA",
		contact_number: "0800 860 6263",
		contact_email: "info@monaoffshorewind.com",
	},

	meta: {
		defaultSocialImage: "/assets/images/social.jpg",
		author: "EnBW Energie Baden-Württemberg",
		description:
			"EnBW Energie Baden-Württemberg AG and bp are proud to be leading the development of the Morgan and Mona projects. These two offshore wind farms in the Irish Sea will help the UK to achieve its ambition of generating 50GW of power from offshore wind by 2030.",
		gtag: "G-MFMY7PV0DY",
		gtm: "GTM-WDFB6BH",
		cookiefirst: "ef0f1e7f-3ba0-49b9-ac84-c2db650e6d18",
	},

	form: {
		feedback: {
			recaptcha: "6Le5HiIgAAAAAGyx8kF9nONhdE-aqXW8dfBOKAp8",
		},

		register: {
			en: {
				catcher_id: "0b845ce865f5",
				honeypot: "",
				recaptcha: "6Lew3SMUAAAAAJ82QoS7gqOTkRI_dhYrFy1f7Sqy"
			},

			cym: {
				catcher_id: "ca63b53ae973",
				honeypot: "",
				recaptcha: "6Lew3SMUAAAAAJ82QoS7gqOTkRI_dhYrFy1f7Sqy"
			}
		}
	},

	consultation: {
		feedback_active: false,
	},

	hasMap: false,

	// Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
	// mapUrl:
	// 	process.env.ELEVENTY_ENV === "dev"
	// 		? "https://bp-enbw-map.jfd-test.co.uk"
	// 		: "https://feedback.morganandmona.com",

	mapUrl: "https://feedback.morganandmona.com",

	// Bugsnag API Key
	bugsnagApiKey: "9f0778bd1d072bd394d3ffb9713b462d",

	// Marker.io Key - replace this default key
	marker_io: "622b2c794731c8207e400f4b",
};
